import { Aptos, AptosConfig } from "@aptos-labs/ts-sdk";
import {
  GasStationClient,
  GasStationTransactionSubmitter,
} from "@aptos-labs/gas-station-client";
import { BKFC_GEOMI_API_KEY, BKFC_NETWORK } from "./config";

// Sponsors gas for functions allowlisted in the Geomi gas station's contract
// rules, so BKFC buyers claim with zero APT. Built lazily (not at module
// scope like the Aptos reference app) so an unconfigured environment doesn't
// throw while the EVM flows load.
// https://geomi.dev/docs/gas-stations
let instance: Aptos | null = null;

export function getBkfcAptos(): Aptos {
  if (!instance) {
    if (BKFC_GEOMI_API_KEY) {
      const gasStationClient = new GasStationClient({
        network: BKFC_NETWORK,
        apiKey: BKFC_GEOMI_API_KEY,
      });
      const transactionSubmitter = new GasStationTransactionSubmitter(
        gasStationClient,
      );
      // pluginSettings.TRANSACTION_SUBMITTER routes transactions built through
      // this config via the gas station instead of the sender paying gas.
      instance = new Aptos(
        new AptosConfig({
          network: BKFC_NETWORK,
          pluginSettings: { TRANSACTION_SUBMITTER: transactionSubmitter },
        }),
      );
    } else {
      // No Geomi key: chain READS (views, indexer, waitForTransaction) must
      // still work — only sponsored submission is unavailable. Environments
      // without the key fall back to the wallet paying gas.
      instance = new Aptos(new AptosConfig({ network: BKFC_NETWORK }));
    }
  }
  return instance;
}
